import React, { useEffect, useMemo } from 'react';
import { Alert, Button, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useLoaderData } from 'react-router-dom';

import Location from '@r6digital/rapidstor-types/react/entities/Location';

import BackLink from '../components/BackLink';
import ContactCard from '../components/ContactPage/ContactCard';

import {
    selectAllLocations,
    useGetLocationsQuery,
} from '../features/rapidstor/rapidstorApiSlice';

function ContactPage() {
    const { isLoading, error, refetch } = useGetLocationsQuery();
    const location = useLoaderData() as Location | null;
    const locations = useSelector(selectAllLocations);
    const locationCode = useMemo(() => location?.locationCode ?? null, [location]);

    useEffect(() => {
        if (!isLoading) {
            window.CallTrk?.swap();
        }
    }, [isLoading]);

    let content;

    if (isLoading) {
        content = <Col>Loading locations...</Col>;
    } else if (error) {
        content = (
            <Col>
                <Alert>
                    Sorry, we were unable to load the list of facilities.
                    <div className={'mt-2'}>
                        <Button onClick={refetch}>Retry</Button>
                    </div>
                </Alert>
            </Col>
        );
    } else {
        content = locations
            .filter((location) => {
                if (!locationCode) {
                    return true;
                }
                return location.locationCode === locationCode;
            })
            .map((location) => (
                <Col lg={4} key={location.locationCode} className={'pb-4'}>
                    <ContactCard location={location} />
                </Col>
            ));
    }

    return (
        <>
            <BackLink desktop />
            <span className={'mt-3 mb-4'}>Contact us</span>
            <Row>{content}</Row>
        </>
    );
}

export default ContactPage;
